/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-danger */
/* eslint-disable no-console */
/* eslint-disable react/jsx-curly-newline */
import { useTranslate } from 'hooks/useTranslate';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';

import Button from 'modules/_shared/components/Buttons';
import EmptyStateCard from 'modules/_shared/components/EmptyStates/EmptyStateCard';
import { hasIntegrations } from 'modules/society/utils/societyHelpers';
import { getFactorialAuthorizeUrl } from 'modules/society/api/getFactorialAuthorizeUrl';

import integrations from 'constants/integrations';
import { dateTimeFormat } from 'constants/formats';
import isSuperAdmin from 'utils/isSuperAdmin';

import './SocietyIntegrations.scss';

const integrationStatus = {
  DISABLED: { name: 'Disabled', color: 'gray' },
  ENABLED: { name: 'Enabled', color: 'info' },
  CONNECTED: { name: 'Connected', color: 'success' },
};

function SocietyIntegrations() {
  const { t, i18n } = useTranslate();

  const user = useSelector((state) => state.user);
  const society = useSelector((state) => state.society?.actualSociety);

  const [integrationKeysOriginal, setIntegrationKeysOriginal] = useState({
    factorial: '',
    personio: '',
  });

  const [integrationKeys, setIntegrationKeys] = useState({
    factorial: '',
    personio: '',
  });

  const [integrationOpen, setIntegrationOpen] = useState({
    factorial: false,
    personio: false,
  });

  const [integrationEdit, setIntegrationEdit] = useState({
    factorial: false,
    personio: false,
  });

  const getIntegrationStatus = (key, value) => {
    let status;

    if (value.enabled) {
      status = value.validated
        ? integrationStatus.CONNECTED
        : integrationStatus.ENABLED;
    } else {
      status = integrationStatus.DISABLED;
    }

    return (
      <span
        className={`badge badge-dot badge-dot-xs text-${status.color} ms-1`}
      >
        {t(status.name)}
      </span>
    );
  };

  const getMaskValue = (key, value) => {
    if (!integrationEdit[key]) {
      return value?.replace(/.(?=.{4})/g, '*');
    }
    return value;
  };

  const handleChangeKeys = (key, value) => {
    setIntegrationKeys({ ...integrationKeys, [key]: value });
  };

  const handleSaveKey = async (key) => {
    if (key === 'factorial') {
      const authorizeUrl = await getFactorialAuthorizeUrl();

      if (authorizeUrl) {
        window.open(authorizeUrl, '_blank')?.focus();
      }
    }
  };

  const handleEditKey = (key) => {
    setIntegrationEdit({ ...integrationEdit, [key]: true });
    setIntegrationKeys({
      ...integrationKeys,
      [key]: integrationKeysOriginal[key],
    });
  };

  useEffect(() => {
    if (society?.integrations) {
      const keyValues = {};
      Object.entries(society.integrations).forEach(([key, value]) => {
        keyValues[key] = value?.key || '';
      });
      setIntegrationKeys(keyValues);
      setIntegrationKeysOriginal(keyValues);
    }
  }, [society]);

  return (
    <div className="nk-block">
      <div className="nk-block-head">
        <div className="nk-block-head-content">
          <h5 className="nk-block-title">{t('Integrations')}</h5>
          <div className="nk-block-des">
            <p>{t('IntegrationsTabDescription')}</p>
          </div>
        </div>
      </div>
      <div className="card card-bordered">
        <ul className="nk-support">
          {!hasIntegrations(society) ? (
            <EmptyStateCard
              mainMessage={t('ErrorNoIntegrations')}
              infoMessage={t('ErrorNoIntegrationsDescription')}
            />
          ) : (
            Object.entries(society.integrations).map(([key, value]) => (
              <li
                key={key}
                className={`nk-support-item integration ${
                  value?.enabled || isSuperAdmin(user) ? 'enabled' : 'disabled'
                }`}
              >
                <div className="integration-item">
                  <div className="integration-logo-box">
                    <img
                      src={integrations[key]?.logo}
                      alt={integrations[key]?.name}
                    />
                  </div>

                  <div className="nk-support-content">
                    <div className="title">
                      <span>{integrations[key]?.name}</span>
                      {getIntegrationStatus(key, value)}
                    </div>
                    <p>{t(integrations[key]?.description)}</p>

                    <div className="mt-2">
                      {value?.validated && (
                        <span className="time">
                          {t('IntegrationValidationDate')}:&nbsp;
                          {value?.validatedAt
                            ? format(
                                new Date(value.validatedAt),
                                dateTimeFormat
                              )
                            : '-'}
                        </span>
                      )}
                      {!integrations[key]?.hasApiKey && !value.validated && (
                        <Button
                          type="button"
                          icon="check-circle-fill"
                          className="btn btn-primary text-center justify-content-center"
                          onClick={() => handleSaveKey(key)}
                        >
                          <span>{t('IntegrationButtonValidate')}</span>
                        </Button>
                      )}
                    </div>
                  </div>
                </div>

                {integrations[key]?.hasApiKey && (
                  <div
                    className={`integration-details ${
                      integrationOpen[key] ? 'd-block' : 'd-none'
                    }`}
                  >
                    <div className="d-flex flex-row justify-content-center align-items-end">
                      <div className="col-md-8">
                        <div className="form-group">
                          <label className="form-label" htmlFor="display-name">
                            {t('IntegrationEnterCode')}:
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-lg"
                            value={getMaskValue(key, integrationKeys[key])}
                            onChange={(event) =>
                              handleChangeKeys(key, event.target.value)
                            }
                            disabled={!integrationEdit[key]}
                            placeholder="..."
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        {integrationEdit[key] ? (
                          <Button
                            type="button"
                            icon="check-circle-fill"
                            className="btn btn-primary btn-lg w-100 text-center justify-content-center"
                            onClick={() => {
                              handleSaveKey(key, integrationKeys[key]);
                            }}
                          >
                            <span>{t('IntegrationButtonValidate')}</span>
                          </Button>
                        ) : (
                          <Button
                            type="button"
                            icon="edit"
                            className="btn btn-primary btn-lg w-100 text-center justify-content-center"
                            onClick={() => {
                              handleEditKey(key);
                            }}
                          >
                            <span>{t('IntegrationButtonEdit')}</span>
                          </Button>
                        )}
                      </div>
                    </div>

                    {integrations[key]?.instructions?.[i18n.language] && (
                      <div className="col-md-12 mt-4">
                        <div
                          className="alert alert-pro alert-primary bg-primary-dim"
                          dangerouslySetInnerHTML={{
                            __html:
                              integrations[key].instructions[i18n.language],
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}
              </li>
            ))
          )}
        </ul>
      </div>
    </div>
  );
}

export default SocietyIntegrations;
